<template>
  <div class="eye-contact-row">
    <label class="eye-contact-question">{{ label }}</label>
    <vue-slider
      class="eye-contact-slider"
      :min="0"
      :max="6"
      :interval="1"
      :data="attentionTypes"
      :data-value="'level'"
      :data-label="'label'"
      :tooltip="'hover'"
      :tooltip-formatter="value => tooltips[value]"
      :adsorb="true"
      :height="6"
      :dot-size="20"
      :value="value"
      :disabled="disabled"
      @change="(value) => $emit('change', value)"
    />
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import { attentionTypes, attentionTooltips as tooltips } from '../../../../lib/common/utils/attentionTypes';

export default {
  name: 'eye-contact-slider',
  components: { VueSlider },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      default: 3,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change'],
  data() {
    return { attentionTypes, tooltips };
  },
};
</script>

<style scoped>
.eye-contact-row {
  margin-bottom: 50px;
}

.eye-contact-row:last-child {
  margin-bottom: 10px;
}

.eye-contact-question {
  margin: 0 0 16px 0;
}
</style>
